import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const arrows_circle_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M4.5098,11.9997 C4.5178,7.8577 7.8818,4.5057
        12.0238,4.51368571 C14.9358,4.5197 18.2618,6.8597 19.4898,9.4997 M19.5,5.01
        L19.49,9.5 L15,9.5 M19.5,11.9997 C19.484,16.1467 16.109,19.4967 11.961,19.4807571
        C9.067,19.4707 5.747,17.1267 4.51,14.5097 M4.5,18.9997 L4.51,14.5097 L9,14.4997"
      />
    </svg>
  );
};
